// Este un ejemplo del array de artículos que le llegaran por props al Slider
// Para renderizar el slider:
// <Slider mostFavoriteArticles={aquiVaElArrayConLosArticulosAmostrar} />

export const mostFavoriteArticles = [
   {
    "id": "f6c3a322-9ec0-42fc-a306-efce7b6f69c8",
    "title": "Samsung Galaxy S22",
    "rating": 4.4,
    "detail": "Es un kit de nivel profesional que cabe en una mano. La cámara posterior triple y la cámara de selfie ofrecen hardware y software de cámara innovadores para que puedas capturar fácilmente una galería llena de contenido digno de compartir.",
    "marca": "Samsung",
    "modelo": "S22",
    "so": "Android",
    "cpu": "Octa-Core de 2.99GHz",
    "ram": "8GB",
    "color": "Green",
    "pantalla": "6.1",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406158/ecom/71PnneF5LRL._AC_SX522__xx72jv.jpg",
    "stock": 3,
    "disable": false,
    "price": 1593,
    "conectividad": "USB Type-C, USB 3.2 Gen 1"
},
{
    "id": "e3db4928-97f8-4d1d-ae16-eee31794504e",
    "title": "Samsung Galaxy S22 Ultra",
    "rating": 4.6,
    "detail": "Conocé el Galaxy S22 Ultra, con el poder del Note. El marco pulido, delgado y audaz, rodea la forma extruida para lograr una simetria elegamte. Y la cámara lineal, acentuada por anillos de lentes espejados, parece flotar en su lugar.",
    "marca": "Samsung",
    "modelo": "S22 Ultra",
    "so": "Android",
    "cpu": "2.99GHz, 2.4GHz, 1.7GHz",
    "ram": "12GB",
    "color": "Green, Black, White, Burgundy",
    "pantalla": "8.9",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406222/ecom/D_NQ_NP_668050-MLA49303776893_032022-O_dvw71o.webp",
    "stock": 4,
    "disable": false,
    "price": 2449,
    "conectividad": "USB Type-C, USB 3.2 Gen 1"
},
{
    "id": "206974b9-efba-48a7-a21c-813e71d0dd2d",
    "title": "Samsung Galaxy S21+ 5G",
    "rating": 4.6,
    "detail": "Video de 8K es la resolución más alta en un teléfono inteligente, lo que hace que tu contenido luzca aún mejor que el cine. Y con 8K 24 fps, cada vlog y memoria es tu próxima toma al estrellato. Grabá, cargá y mirá directamente en YouTube.",
    "marca": "Samsung",
    "modelo": "S21+ 5G",
    "so": "Android",
    "cpu": "2.9GHz, 2.8GHz, 2.2GHz",
    "ram": "8GB",
    "color": "Violet",
    "pantalla": "6.2",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406359/ecom/D_NQ_NP_908285-MLA50209440689_062022-O_pvxcpn.webp",
    "stock": 2,
    "disable": false,
    "price": 1622,
    "conectividad": "USB Type-C, USB 3.2 Gen 1"
},
{
    "id": "12f62185-4c54-4a81-b40c-e32a416d0474",
    "title": "Samsung Galaxy S21 FE 5G",
    "rating": 4.6,
    "detail": "Ya no volverás a perderte esa toma perfecta. Conocé los Galaxy S21 5G y S21+ 5G. Están diseñados para revolucionar el video y la fotografía, con una resolución cinematográfica de 8K para que puedas tomar fotos épicas mientras hacés un video. Ambos modelos tienen todas las características que necesitás: 64 MP, el conjunto de chips más rápido y una batería increíble que dura todo el día.1 Tu mundo va a ser realmente épico.",
    "marca": "Samsung",
    "modelo": "S21",
    "so": "Android",
    "cpu": "2.9GHz, 2.8GHz, 2.2GHz",
    "ram": "8GB",
    "color": "Gray",
    "pantalla": "6.2",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406332/ecom/D_NQ_NP_730981-MLA48800008115_012022-O_esaofd.webp",
    "stock": 1,
    "disable": false,
    "price": 1291,
    "conectividad": "USB Type-C, USB 3.2 Gen 1"
},
{
    "id": "c63579ec-4233-4b48-82f5-b5417f1957c1",
    "title": "Samsung Galaxy Z Fold3 5G",
    "rating": 4.6,
    "detail": "Esto es todo lo que querías en un smartphone 5G duradero y de primera calidad. Lo creamos plegable para revelar una enorme pantalla en la que puedas ver, trabajar y divertirte como nunca antes.",
    "marca": "Samsung",
    "modelo": "Fold3",
    "so": "Android",
    "cpu": "2.84GHz, 2.4GHz, 1.8GHz",
    "ram": "12GB",
    "color": "Silver",
    "pantalla": "7.6",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406419/ecom/D_NQ_NP_680610-MLA47574356658_092021-O_n1nbwo.webp",
    "stock": 7,
    "disable": false,
    "price": 1955,
    "conectividad": "USB Type-C, USB 3.2 Gen 1"
},
{
    "id": "605c667d-c721-43bd-87b7-69317545a30e",
    "title": "Samsung Z Flip4",
    "rating": 4.2,
    "detail": "Elegí un color que combine con todo, pero que no se parezca a nada. Un acabado opaco en el vidrio crea un contraste suave con el marco de metal brillante. Seleccioná entre cuatro tonos: Bora Purple, Graphite, Pink Gold y Blue.",
    "marca": "Samsung",
    "modelo": "Flip4",
    "so": "Android",
    "cpu": "2.99GHz, 2.4GHz, 1.7GHz",
    "ram": "12GB",
    "color": "Bora Purple, Graphite, Pink y Blue",
    "pantalla": "7.3",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406441/ecom/D_NQ_NP_624071-MLA47717269574_092021-O_rnlvi5.webp",
    "stock": 3,
    "disable": false,
    "price": 1593,
    "conectividad": "USB Type-C, USB 3.2 Gen 1"
},
{
    "id": "9ee86065-1b9c-4247-9cc3-66f1a773b981",
    "title": "Samsung Galaxy Z Fold2",
    "rating": 4.7,
    "detail": "Conocé el smartphone que está cambiando la forma del futuro. El número uno del mundo en plegables, este smartphone de última generación pone en la palma de tu mano un potente rendimiento, cristal plegable y una batería para todo el día",
    "marca": "Samsung",
    "modelo": "Fold2",
    "so": "Android",
    "cpu": "Octa-Core de 3.09GHz, 2.4GHz, 1.8GHz",
    "ram": "12GB",
    "color": "Green, Bronce",
    "pantalla": "7.6",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406471/ecom/ar-galaxy-z-fold2-f916-341065-sm-f916bznqaro-thumb-344960155_ofmsrm.webp",
    "stock": 10,
    "disable": false,
    "price": 2449,
    "conectividad": "USB Type-C, USB 3.2 Gen 1"
},
{
    "id": "3df847e2-26b5-4313-b384-4216814199c1",
    "title": "Samsung Galaxy Z Flip3 5G",
    "rating": 4.6,
    "detail": "Se pliega en el bolsillo. Entra en tu cartera. Se desliza en tus jeans más apretados. Cuando lo sacás, se abre un smartphone 5G con pantalla completa que se adapta a tus ángulos favoritos.",
    "marca": "Samsung",
    "modelo": "Flip3",
    "so": "Android",
    "cpu": "2.84GHz, 2.4GHz, 1.8GHz",
    "ram": "8GB",
    "color": "Black",
    "pantalla": "6.7",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406397/ecom/D_NQ_NP_618327-MLA48897052450_012022-O_cjtp0f.webp",
    "stock": 3,
    "disable": false,
    "price": 1955,
    "conectividad": "USB Type-C, USB 2.0"
},
{
    "id": "294636f2-c8f4-4ce7-b782-a4747464ffb0",
    "title": "Samsung Galaxy A51",
    "rating": 4.3,
    "detail": "Obtené la experiencia más reciente de Galaxy en tu teléfono. Actualizá el software para explorar la nuevas funciones disponibles.",
    "marca": "Samsung",
    "modelo": "A51",
    "so": "Android",
    "cpu": "Octa-Core de 2.3GHz, 1.7GHz",
    "ram": "4GB",
    "color": "Black, White",
    "pantalla": "6.5",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661466378/ecom/D_NQ_NP_622636-MLA50113502606_052022-O_hlkqwc.webp",
    "stock": 7,
    "disable": false,
    "price": 761,
    "conectividad": "USB Type-C, USB 2.0"
},
{
    "id": "7b231158-2ff4-4322-ac33-6a618a851dcf",
    "title": "Samsung Galaxy A33 5G",
    "rating": 4,
    "detail": "Alimentado con un procesador Octa-core de 5 nm, tu Galaxy está diseñado para manejar múltiples tareas. ram Plus lee tus patrones de uso y proporciona ram virtual adicional en los momentos que necesitás un impulso adicional.",
    "marca": "Samsung",
    "modelo": "A33",
    "so": "Android",
    "cpu": "Octa-Core de 5 nm",
    "ram": "6GB",
    "color": "Awesome Peach, Black, White, Blue",
    "pantalla": "6.4",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661406525/ecom/D_NQ_NP_737517-MLA50739491200_072022-O_atdpui.webp",
    "stock": 8,
    "disable": false,
    "price": 590,
    "conectividad": "USB Type-C, USB 2.0"
},
{
    "id": "1bca3c14-e198-4e25-9ead-fd62188c79ae",
    "title": "Samsung Galaxy A71",
    "rating": 4.4,
    "detail": "Con un diseño de pantalla suave y elegante de borde curvo, Galaxy A71 es hermoso a la vista y se adapta cómodamente a la mano. Su acabado brillante premium lo hace fácil de sostener, y el patrón dinámico agrega un toque único de personalidad a cada una de sus ediciones Black y Silver.",
    "marca": "Samsung",
    "modelo": "A71",
    "so": "Android",
    "cpu": "Octa-Core de 2.2GHz, 1.8GHz",
    "ram": "6GB",
    "color": "Black, Silver",
    "pantalla": "6.7",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661466435/ecom/D_NQ_NP_815858-MLA41632030909_052020-O_x72uyq.webp",
    "stock": 12,
    "disable": false,
    "price": 961,
    "conectividad": "USB Type-C, USB 2.0"
},
{
    "id": "d64e91d0-e58a-49e4-8613-df09371057a1",
    "title": "Samsung Galaxy A52",
    "rating": 4.6,
    "detail": "Disfrutá de los detalles realmente vibrantes con la pantalla Super AMOLED Display FHD+, que alcanza los 800 nits para mayor claridad, incluso con la luz de día brillante. Eye Comfort Shield² reduce la luz azul y la pantalla extrafluida mantiene la vista relajada, ya sea que estés jugando o navegando. Todo en la amplia pantalla Infinity-O Display de 6,5 pulgadas.",
    "marca": "Samsung",
    "modelo": "A52",
    "so": "Android",
    "cpu": "Octa-Core de 2.3GHz, 1.8GHz",
    "ram": "6GB",
    "color": "Blue, Black, White, Violet",
    "pantalla": "6.5",
    "image": "https://res.cloudinary.com/dsalyp6sj/image/upload/v1661466411/ecom/D_NQ_NP_861218-MLA50576439367_072022-O_mhtbhi.webp",
    "stock": 10,
    "disable": false,
    "price": 848,
    "conectividad": "USB Type-C, USB 2.0"
}
]